import { type Api } from "api-client";
import { Checkbox, CommandItem } from "ui";

import { type WorkoutItemAttributePickerContentProps } from "./WorkoutItemAttributePicker";

interface WorkoutItemAttributePickerItemProps extends WorkoutItemAttributePickerContentProps {
  attribute: Api.ListExerciseAttributes.Output.Item;
  label: string;
}

export function WorkoutItemAttributePickerItem(
  props: WorkoutItemAttributePickerItemProps,
) {
  const selected = props.selectedAttributeIds.includes(props.attribute.id);

  function handleSelect() {
    if (props.onCheckedChange) {
      props.onCheckedChange(props.attribute.id, !selected, props.attribute);
      return;
    }

    if (props.onSelect) {
      props.onSelect(props.attribute);
      props.close();
    }
  }

  return (
    <CommandItem
      value={`${props.label} ${props.attribute.id}`}
      disabled={props.disabled}
      onSelect={handleSelect}
    >
      {props.renderAttribute ? (
        props.renderAttribute({
          attribute: props.attribute,
          label: props.label,
          selected,
          disabled: props.disabled,
          close: props.close,
        })
      ) : props.onCheckedChange ? (
        <>
          <Checkbox
            aria-label={props.label}
            checked={selected}
            disabled={props.disabled}
            onClick={(event) => event.stopPropagation()}
            onCheckedChange={(checked) => {
              props.onCheckedChange?.(
                props.attribute.id,
                checked === true,
                props.attribute,
              );
            }}
          />
          <span className="flex-1">{props.label}</span>
        </>
      ) : (
        <span className="flex-1">{props.label}</span>
      )}
    </CommandItem>
  );
}
